import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import EditorPage from "./pages/EditorPage";
import EditorRouter from "./pages/EditorRouter";
import LegalPage from "./pages/LegalPage";
import PlanesPage from "./pages/PlanesPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuthStore } from "./store/authStore";
import { useConfigStore } from "./store/configStore";
import { Toaster } from "sonner";
import { APP_VERSION } from "./version";
import { I18nProvider } from "./i18n";
import LanguageSwitcher from "./components/LanguageSwitcher";
import "@/App.css";

function App() {
  const { token, checkAuth } = useAuthStore();
  const theme = useConfigStore((s) => s.theme);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <I18nProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={token ? <Navigate to="/dashboard" /> : <Navigate to="/auth" />}
          />
          <Route
            path="/auth"
            element={!token ? <AuthPage /> : <Navigate to="/dashboard" />}
          />
          {/* Enlace de reset del correo: siempre público (AuthPage lee ?token=). */}
          <Route path="/reset-password" element={<AuthPage />} />
          {/* Public legal documents (no auth): /legal/terms, /legal/privacy */}
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          {/* T-087: información de planes/paquetes + instrucciones de pago (manual). */}
          <Route
            path="/planes"
            element={
              <ProtectedRoute>
                <PlanesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/document/:documentId"
            element={
              <ProtectedRoute>
                <EditorRouter />
              </ProtectedRoute>
            }
          />
          {/* Legacy routes for backward compatibility */}
          <Route
            path="/editor/:documentId"
            element={
              <ProtectedRoute>
                <EditorPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme={theme} />
      {/* Selector de idioma + versión del sistema, visibles siempre. Abajo-IZQUIERDA
          (T-123): a la derecha tapaba el control de zoom de la barra de conteo. */}
      <div
        style={{
          position: 'fixed', bottom: 6, left: 8, zIndex: 9999,
          display: 'flex', alignItems: 'center', gap: 8,
        }}
      >
        <LanguageSwitcher />
        <span
          title="Versión del sistema"
          style={{
            fontSize: 11, lineHeight: 1, opacity: 0.55,
            fontFamily: 'ui-monospace, monospace', userSelect: 'none',
          }}
        >
          v{APP_VERSION}
        </span>
      </div>
    </div>
    </I18nProvider>
  );
}

export default App;
